/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  Modal,
  Form,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import { Link } from "react-router-dom";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import TableContainer from "../../Components/Common/TableContainer";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useProfile } from "../../Components/Hooks/UserHooks";
import { createDeliveryInstructions, deleteDeliveryInstructionsById, ListDeliveryInstructions, updateDeliveryInstructions } from "./_requests";

const DeliveryInstructions = (data: any) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [DeliveryInstructions, setDeliveryInstructions] = useState<Array<{ id: string; name: string; description: string; icon?: string }>>([]);
  const [Roles, setRoles] = useState<any>([]);
  const [DeliveryInstructionsaccess, setDeliveryInstructionsaccess] = useState<any>([]);
  const { userProfile } = useProfile();
  const [modal, setModal] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);
  const [DeliveryInstructionsToDeleteId, setDeliveryInstructionsToDeleteId] = useState<string>("");
  const [DeliveryInstructionsToDeleteName, setDeliveryInstructionsToDeleteName] = useState<string>("");
  const [Duplicate, setDuplicate] = useState<any>("");
  const [selectedImage, setSelectedImage] = useState<any>();
  const [Email, setEmail] = useState("");
  const toggle = useCallback(() => {
    setModal(!modal);
    setDuplicate("");
  }, [modal]);

  useEffect(() => {
    // getCRUD(userProfile?.role, ).then((res: any) => {
    //   setStoreaccess(res.Data[0]);
    // });
  }, []);


  const toggleDeleteModal = useCallback(() => {
    setDeleteModalOpen(!deleteModalOpen);
  }, [deleteModalOpen]);

  useEffect(() => {
    fetchDeliveryInstructions();
  }, []);

  const fetchDeliveryInstructions = () => {
    ListDeliveryInstructions().then((res: any) => {
      setDeliveryInstructions(res.data);
    });
  };



  // Delete Data
  const onClickDelete = useCallback(
    (DeliveryInstructions: any) => {
      setDeliveryInstructionsToDeleteName(DeliveryInstructions.name);
      setDeliveryInstructionsToDeleteId(DeliveryInstructions.id);

      setDeliveryInstructionsaccess((prevDepAccess: any) => {
        // if (prevDepAccess?.remove === 1) {
          toggleDeleteModal();
        // } else {
        //   toast.error("You don't have permission to access this page", {
        //     position: "top-right",
        //     style: {
        //       backgroundColor: "#9b2313",
        //       color: "#c7c7d7",
        //       fontSize: "14px",
        //     },
        //     closeButton: false,
        //   });
        // }
        return prevDepAccess;
      });
    },
    [setDeliveryInstructionsToDeleteName, setDeliveryInstructionsToDeleteId, toggleDeleteModal]
  );

  // validation
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      name: "",
      description: "",
      icon:"",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
     
      icon: Yup.mixed().test(
        "icon-required",
        "Icon is required",
        function (value) {
          // Only require icon if not editing (add mode)
          if (!isEdit) {
            // Use this.value instead of selectedImage for Formik context
            return !!value;
          }
          return true;
        }
      ),
    }),
    onSubmit: async (values: any) => {
      try {
        const formData = new FormData();
        formData.append("name", values.name);
        formData.append("description", values.description);
        formData.append(isEdit ? "updated_by" : "created_by", userProfile?.userId);

        if (values.icon) {
          formData.append(isEdit ? "iconNew" : "icon", values.icon);
        }
        if (isEdit) {
          await updateDeliveryInstructions(formData, values.id);
          toast.success("Delivery Instructions updated Successfully", { autoClose: 3000 });
        } else {
          await createDeliveryInstructions(formData);
          toast.success("Delivery Instructions created Successfully", { autoClose: 3000 });
        }

        fetchDeliveryInstructions();
        validation.resetForm();
        setSelectedImage("");
        setPreviewImage("");
        toggle();
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong", { autoClose: 3000 });
      }
    },
  });

  const confirmDelete = async (StoreId: any) => {
    await deleteDeliveryInstructionsById(StoreId ,userProfile?.userId);
    toggleDeleteModal();
    toast.success("Delivery Instructions deleted Successfully", { autoClose: 3000 });
    fetchDeliveryInstructions();
  };

  // Update Data
  const handleDeliveryInstructionsClick = useCallback(
    (DeliveryInstructions: any) => {
      validation.setValues({
        id: DeliveryInstructions.id,
        name: DeliveryInstructions.name,
        description: DeliveryInstructions.description,
      });
      setPreviewImage(DeliveryInstructions.icon);
      setIsEdit(true);

      setDeliveryInstructionsaccess((prevDepAccess: any) => {
        // if (prevDepAccess?.edit === 1) {
        toggle();
        // } else {
        //   toast.error("You don't have permission to access this page", {
        //     position: "top-right",
        //     style: {
        //       backgroundColor: "#9b2313",
        //       color: "#c7c7d7",
        //       fontSize: "14px",
        //     },
        //     closeButton: false,
        //   });
        // }
        return prevDepAccess;
      });
    },
    [toggle, validation]
  );

  const [previewImage, setPreviewImage] = useState<string | null>(null); // Optional for preview

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if (files && files[0]) {
      const file = files[0];
      setSelectedImage(file);
      validation.setFieldValue("icon", file);

      // Optional: Generate a base64 preview (for image preview purposes)
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && e.target.result) {
          setPreviewImage(e.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  // Delivery Instructions Column
  const columns = useMemo(
    () => [
      {
        header: "S.No",
        id: "sno",
        enableColumnFilter: false,
        cell: (cellProps: any) => {
          const { pageIndex, pageSize } = cellProps.table.getState().pagination;
          return pageIndex * pageSize + cellProps.row.index + 1;
        },
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-sm bg-light rounded p-1">
                  <img
                    src={cell.row.original.icon}
                    alt=""
                    className="img-fluid d-block"
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                    {cell.getValue()}
                </h5>
              </div>
            </div>
          </>
        ),
      },,
      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
      },

      {
        header: "Action",
        cell: (cellProps: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to="#"
                  className="text-primary d-inline-block edit-item-btn"
                  onClick={() => {
                    const DeliveryInstructionsData = cellProps.row.original;
                    handleDeliveryInstructionsClick(DeliveryInstructionsData);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => {
                    const DeliveryInstructionsData = cellProps.row.original;
                    onClickDelete(DeliveryInstructionsData);
                  }}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleDeliveryInstructionsClick, onClickDelete]
  );

  const addDeliveryInstructions = () => {
    setIsEdit(false);
    setPreviewImage("");
    setSelectedImage("");
    toggle();
    validation.setValues({ id: "", name: "", description: "", icon: "" });
    validation.setTouched({});
    validation.setErrors({});
  };

  document.title = " Paal Dappa | Admin panel";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="DeliveryInstructions" pageTitle="Dashboard" />
          <Row>
            <Col lg={12}>
              <Card id="DeliveryInstructionsList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">Delivery Instructions List</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>
                        <button
                          type="button"
                          className="btn text-white add-btn me-1"
                          style={{
                            backgroundColor: "#28a8df",
                            borderColor: "#28a8df",
                          }}
                          id="create-btn"
                          onClick={addDeliveryInstructions}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add
                          Delivery Instructions
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className="card-body pt-0">
                  <div>
                    <TableContainer
                      columns={columns}
                      data={DeliveryInstructions || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive table-card mb-3"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      SearchPlaceholder="Search Delivery Instructions..."
                    />
                  </div>

                  <Modal id="showModal" isOpen={modal} toggle={toggle} centered>
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Delivery Instructions" : "Add Delivery Instructions"}
                    </ModalHeader>
                    <Form
                      className="tablelist-form"
                      onSubmit={(e: any) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <input type="hidden" id="id-field" />
                        <div className="text-center">
                          <div className="position-relative d-inline-block">
                            <div>
                              Icon <span className="text-danger">*</span>
                            </div>
                            <div className="position-absolute  bottom-0 end-0">
                              <Label htmlFor="customer-image-input" className="mb-0">
                                <div className="avatar-xs cursor-pointer">
                                  <div className="avatar-title bg-light border rounded-circle text-muted">
                                    <i className="ri-image-fill"></i>
                                  </div>
                                </div>
                              </Label>
                              <Input
                                name="icon"
                                className="form-control d-none"
                                id="customer-image-input"
                                type="file"
                                accept="image/png, image/gif, image/jpeg"
                                onChange={handleImageChange}
                              />
                            </div>
                            <div className="avatar-lg p-1">
                              <div className="avatar-title bg-light rounded-circle">
                                <img
                                  src={previewImage || dummyImg}
                                  alt="dummyImg"
                                  id="customer-img"
                                  className="avatar-md rounded-circle object-fit-cover"
                                />
                              </div>
                            </div>
                         
                          </div>
                             {validation.touched.icon && validation.errors.icon ? (
                              <div className="text-danger small">{validation.errors.icon}</div>
                            ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="Storename-field" className="form-label">
                            Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name"
                            id="Storename-field"
                            className="form-control"
                            placeholder="Enter Name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={validation.touched.name && !!validation.errors.name}
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="Description-field" className="form-label">
                            Description <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="description"
                            id="Description-field"
                            className="form-control"
                            placeholder="Enter Description"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description || ""}
                            invalid={validation.touched.description && !!validation.errors.description}
                          />
                          {validation.touched.description && validation.errors.description ? (
                            <FormFeedback type="invalid">
                              {validation.errors.description}
                            </FormFeedback>
                          ) : null}
                        </div>
                    
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn text-white add-btn me-1"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                            onClick={() => {
                              setModal(false);
                            }}
                          >
                            {" "}
                            Close{" "}
                          </button>

                          <button
                            type="submit"
                            className="btn text-white add-btn me-1"
                            style={{
                              backgroundColor: "#28a8df",
                              borderColor: "#28a8df",
                            }}
                            disabled={Duplicate}
                          >
                            {" "}
                            {!!isEdit ? "Update" : "Add Delivery Instructions"}{" "}
                          </button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                  <ToastContainer closeButton={false} limit={1} />
                </div>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={deleteModalOpen} toggle={toggleDeleteModal} centered>
            <ModalHeader toggle={toggleDeleteModal}>
              Confirm Deletion
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete the Delivery Instructions{" "}
              <strong>{DeliveryInstructionsToDeleteName}</strong>?
            </ModalBody>
            <ModalFooter>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={toggleDeleteModal}
              >
                Cancel
              </Button>
              <Button
                className="btn text-white add-btn me-1"
                style={{
                  backgroundColor: "#28a8df",
                  borderColor: "#28a8df",
                }}
                onClick={() => {
                  confirmDelete(DeliveryInstructionsToDeleteId);
                  setModal(false);
                }}
              >
                Delete
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DeliveryInstructions;
        

